import React from 'react';
import LocationTemplate from './LocationTemplate';

const GriftonPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Grifton"
      stateName="North Carolina"
      countyName="Pitt/Lenoir"
      zipCodes={["28530"]}
      latitude={35.3713}
      longitude={-77.4369}
      population={2617}
      historicalFact="Established in the 1760s as Bell's Ferry; straddles two counties."
      nearbyTowns={[
        "Kinston, NC",
        "Ayden, NC",
        "Winterville, NC",
        "Snow Hill, NC",
        "Hookerton, NC",
        "La Grange, NC",
        "Dover, NC",
        "Deep Run, NC"
      ]}
    />
  );
};

export default GriftonPage;